<template>
    <div v-if="fetcher.initialized">

        <div class="page-header" :class="{ 'active' : showPageHeader }">

            <div class="container-fluid">
                <div class="page-title">{{ pageTitle }}</div>
            </div>

        </div>

        <div class="page-body">

            <div class="container-fluid">
                <h1 class="mb-4">{{ pageTitle }}</h1>
                <div class="mb-6">
                    <button class="btn btn-sm me-2"
                            :class="{ 'btn-primary' : language == 'sv', 'btn-outline-primary' : language != 'sv' }"
                            @click="setActiveLanguage('sv')"
                            v-if="hasMassage"
                    >
                      <span v-if="hasPt">Massage - Svenska</span>
                      <span v-else>Svenska</span>
                    </button>
                    <button class="btn btn-sm me-2"
                            :class="{ 'btn-primary' : language == 'en', 'btn-outline-primary' : language != 'en' }"
                            @click="setActiveLanguage('en')"
                            v-if="hasMassage"
                    >
                      <span v-if="hasPt">Massage - English</span>
                      <span v-else>English</span>
                    </button>

                    <button class="btn btn-sm me-2"
                            :class="{ 'btn-primary' : language == 'pt', 'btn-outline-primary' : language != 'pt' }"
                            @click="setActiveLanguage('pt')"
                            v-if="hasMassage && hasPt"
                    >
                      PT - Svenska
                    </button>
                </div>
            </div>

            <div class="faq-list mt-4">

                <div class="faq-list-item" :class="{ 'active' : activeQuestion === question.id }" :key="'q'+question.id"
                     v-for="question in questionsForLanguage">
                    <div class="container-fluid">

                        <div class="question" @click="setActiveQuestion(question.id)">
                            <h4>{{ question.title }}</h4>
                            <div class="fold-icon"></div>
                        </div>

                        <div class="answer">
                            <p class="mb-0" v-html="question.answer"></p>
                        </div>

                    </div>
                </div>

            </div>

            <transition name="fade">
                <div class="container-fluid mt-8" v-if="questions.length">
                    <h1>Hittar du inte svaret?</h1>
                    <p>Kontakta oss genom att skicka e-post till <a
                        href="mailto:info@halsoresurs.se">info@halsoresurs.se</a></p>
                </div>
            </transition>

            <div class="container-fluid pt-12" v-if="app_version === 'customer_card'">

                <h3>Besöksstatistik</h3>
                <p class="mb-4">Vi använder Matomo Cloud för att samla in statistik som används till att förbättra upplevelsen i vår webb-app. Vi registrerar inga personuppgifter eller tredjepartscookies.</p>

                <div class="form-check">
                  <input class="form-check-input" type="checkbox" id="optout" :checked="matomoTrack" @change="setMatomoOptOutIn">
                  <label class="form-check-label" for="optout">
                    Inkludera mig i statistiken
                  </label>
                </div>

                <p class="pt-2" v-if="optOutText"><b>{{ optOutText }}</b></p>

            </div>

        </div>

    </div>
</template>

<script>
import scrollMixin from '../../../shared/mixins/scrollMixin'
import fetcher from '../../../shared/mixins/fetcher'

export default {

    mixins: [
        scrollMixin,
        fetcher
    ],

    components: {},

    data () {
        return {
            pageTitle: 'Frågor & svar',
            showPageHeader: false,
            activeQuestion: 0,
            language: 'sv', // sv || en || pt
            matomoTrack: false,

            hasMassage: false,
            hasPt: false,
            questions: [],
            questions_en: [],
            questions_pt: [],
            fetcher: {
                autoFill: [
                    'hasMassage',
                    'hasPt',
                    'questions',
                    'questions_en',
                    'questions_pt'
                ]
            }
        }
    },

    created () {
        if (this.app_version === 'customer_card') {
            const self = this
            window._paq.push([function () {
                self.matomoTrack = !this.isUserOptedOut()
            }])
        }
    },

    computed: {
        fetcherUrl () {
            return '/faq'
        },
        questionsForLanguage () {
            if (this.language === 'pt') {
                return this.questions_pt
            }

            return this.language === 'sv' ? this.questions : this.questions_en
        },
        optOutText () {
            return this.matomoTrack ? '' : 'Du inkluderas inte i statistiken.'
        }
    },

    methods: {

        fetcherSuccess () {
            if (!this.hasMassage && this.hasPt) {
                this.language = 'pt'
            }
        },

        setActiveLanguage (language) {
            this.language = language
            this.activeQuestion = 0

            this.matomoTrackEvent('FAQ', 'Language', language)
        },

        setActiveQuestion (question) {
            if (this.activeQuestion == question) {
                this.activeQuestion = 0
            } else {
                this.activeQuestion = question
            }
        },

        setMatomoOptOutIn () {
            if (!this.matomoTrack) {
                window._paq.push(['forgetUserOptOut'])
            } else {
                window._paq.push(['optUserOut'])
            }

            this.matomoTrack = !this.matomoTrack
        }

    }
}
</script>
<style type="text/css">

/* --- Fade transition --- */
.fade-enter-active, .fade-leave-active {
    transition: all 250ms;
}

.fade-enter, .fade-leave-to {
    opacity: 0;
}
</style>
